import { useLocalStorage } from '@vueuse/core'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export type SessionTransitionT = 'changing-organisation' | 'changing-user' | 'logging-out'
export type HelpPanelTabT = 'current-page' | 'agent-help' | 'tutorials'

export const useUiStore = defineStore('ui', () => {
  const useFullScreenLayout = ref(false)
  const demoModeActivated = ref(false)
  const sessionTransition = ref<SessionTransitionT>()
  const helpPanelOpen = ref(false)
  const helpPanelActiveTab = ref<HelpPanelTabT>()
  const isSessionTransitioning = computed(() => sessionTransition.value !== undefined)

  // Developer/demo toggle. Keep false for the simplified client UX where each property has one
  // implicit planning scenario; set true locally to demo multi-scenario CRUD.
  const enableMultiplePlanningScenarios = ref(false)
  const useFloatingHelpAgent = useLocalStorage('ruminati:dev:use-floating-help-agent', false)

  function setFullScreenLayout(useFullscreen: boolean) {
    useFullScreenLayout.value = useFullscreen
  }

  function setFloatingHelpAgent(useFloating: boolean) {
    useFloatingHelpAgent.value = useFloating
  }

  function toggleFloatingHelpAgent() {
    useFloatingHelpAgent.value = !useFloatingHelpAgent.value
  }

  function startSessionTransition(transition: SessionTransitionT) {
    sessionTransition.value = transition
  }

  function finishSessionTransition() {
    sessionTransition.value = undefined
  }

  function reset() {
    useFullScreenLayout.value = false
    demoModeActivated.value = false
    helpPanelOpen.value = false
    helpPanelActiveTab.value = undefined
  }

  return {
    useFullScreenLayout,
    setFullScreenLayout,
    demoModeActivated,
    helpPanelOpen,
    helpPanelActiveTab,
    enableMultiplePlanningScenarios,
    useFloatingHelpAgent,
    setFloatingHelpAgent,
    toggleFloatingHelpAgent,
    sessionTransition,
    isSessionTransitioning,
    startSessionTransition,
    finishSessionTransition,
    reset,
  }
})
